(function () {
  // 防止同一页面多个 news-slide 实例重复加载本脚本
  if (window.__newsSlideLoaded) return;
  window.__newsSlideLoaded = true;

  function initNewsSlide(container) {
    // 每个实例的容器带唯一 data-news-slide="{{ section.id }}"，
    // 所有节点都只在各自容器内查找，页面存在多个实例时互不干扰
    var sectionId = container.getAttribute('data-news-slide');
    var scope = '[data-news-slide="' + sectionId + '"]';
    var el = container.querySelector('.news-slide__swiper');
    if (!el || typeof Swiper === 'undefined') return;
    if (el.swiper) el.swiper.destroy(true, true);

    var options = {
      slidesPerView: "auto",
      // 默认为移动端（<750px）间距；>=750px 走 breakpoints 恢复 PC 值
      // 左右两端统一保留 24px（slidesOffsetBefore/After）
      spaceBetween: 10,
      slidesOffsetBefore: 24,
      slidesOffsetAfter: 24,
      breakpoints: {
        750: {
          spaceBetween: 20,
          slidesOffsetBefore: 24,
          slidesOffsetAfter: 24,
        },
        // iPad Pro 区间（1024~1193，与 news-slide.css 的媒体查询一致）恢复移动端间距
        1024: {
          spaceBetween: 10,
          slidesOffsetBefore: 24,
          slidesOffsetAfter: 24,
        },
        // >=1194 恢复 PC 端间距
        1194: {
          spaceBetween: 20,
          slidesOffsetBefore: 24,
          slidesOffsetAfter: 24,
        }
      },
      loop: false,
      rewind: container.getAttribute('data-rewind') === 'true',
      speed: 500,
      navigation: {
        prevEl: scope + ' .news-slide__prev',
        nextEl: scope + ' .news-slide__next',
        disabledClass: 'is-disabled',
      }
    };

    if (container.getAttribute('data-autoplay') === 'true') {
      options.autoplay = {
        delay: (parseInt(container.getAttribute('data-autoplay-interval'), 10) || 4) * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    var swiper = new Swiper(el, options);

    initIndicator(swiper, container);
  }

  // 指示器实现，参考 home-category-carousel
  var INDICATOR_MAX = 9;

  function initIndicator(swiper, container) {
    var indicatorContainer = container.querySelector('.news-slide__indicator');
    if (!indicatorContainer) return;

    var slidesCount = swiper.slides.length;
    // slidesPerView 为 "auto" 时，滑到底的 activeIndex 对应 snapGrid 的最后一个吸附点
    // （含最后只露出半张的那一步），按"卡片数 - 可视数"推算会少一步，
    // 导致指示点提前点亮最后一个、末尾半张要再点一次才滑出来；
    // 因此直接用 Swiper 维护的吸附点数量计算可滑动步数
    var maxScroll;
    if (swiper.snapGrid && swiper.snapGrid.length) {
      maxScroll = Math.max(0, swiper.snapGrid.length - 1);
    } else {
      var slidesPerView = parseFloat(swiper.params.slidesPerView) || 1;
      maxScroll = Math.max(0, Math.floor(slidesCount - slidesPerView));
    }
    var size;
    // 指示点数量按卡片数计算，不依赖 snapGrid（宽屏下末端吸附点会被钳制去重，
    // 导致 maxScroll 随视口变化，出现 PC 端只剩 1 个点的问题）
    if (window.innerWidth < 750) {
      // 移动端一屏一张卡：指示点 = 卡片数（3 张卡 → 3 个点：1 激活 + 2 待激活）
      size = Math.min(slidesCount, INDICATOR_MAX);
    } else {
      // PC 端一屏多卡：指示点 = 卡片数 - 1（3 张卡 → 2 个点：1 激活 + 1 待激活）
      size = Math.min(slidesCount - 1, INDICATOR_MAX);
    }

    var html = '';
    if (maxScroll > INDICATOR_MAX) {
      for (var i = 0; i < INDICATOR_MAX; i++) {
        html += i < 5
          ? "<div class='indicator-item' data-mode='large'></div>"
          : "<div class='indicator-item' data-mode='small'></div>";
      }
    } else {
      for (var j = 0; j < size; j++) {
        html += j < Math.ceil(size / 2)
          ? "<div class='indicator-item' data-mode='large'></div>"
          : "<div class='indicator-item' data-mode='small'></div>";
      }
    }
    indicatorContainer.innerHTML = html;

    var items = Array.prototype.slice.call(indicatorContainer.querySelectorAll('.indicator-item'));

    function setActive(index) {
      items.forEach(function (el, i) {
        if (i === index) {
          el.setAttribute('data-active', 'true');
        } else {
          el.removeAttribute('data-active');
        }
      });
    }

    // 大小区段分布随激活位置切换
    function updateModes(index) {
      var count = size;
      var isEven = count % 2 == 0;
      var middleIndex = isEven ? count / 2 : (count + 1) / 2;

      items.forEach(function (el, i) {
        var large;
        if (index < middleIndex) {
          large = i < middleIndex;
        } else {
          large = isEven ? i >= middleIndex : i >= middleIndex - 1;
        }
        el.setAttribute('data-mode', large ? 'large' : 'small');
      });
    }

    // 死区步进的过冲动画：先点亮目标格子，动画结束后回落
    var flashTimer = null;
    var flashIndex = null;

    function cancelFlash() {
      if (flashTimer) {
        clearTimeout(flashTimer);
        flashTimer = null;
      }
      if (flashIndex !== null && items[flashIndex]) {
        items[flashIndex].classList.remove('is-flash');
        flashIndex = null;
      }
    }

    function flashTo(target, fallbackIndex) {
      cancelFlash();
      flashIndex = target;
      setActive(target);
      // 先移除并强制 reflow，确保连续触发时 CSS 动画能重新播放
      items[target].classList.remove('is-flash');
      void items[target].offsetWidth;
      items[target].classList.add('is-flash');
      flashTimer = setTimeout(function () {
        if (flashIndex !== target) return;
        items[target].classList.remove('is-flash');
        flashIndex = null;
        flashTimer = null;
        setActive(fallbackIndex);
      }, 320);
    }

    // 滑动时更新激活态
    function indicatorChange(cardIndex, instant, direction) {
      var index = 0;

      if (cardIndex <= 0) {
        index = 0;
      } else if (cardIndex >= maxScroll) {
        // 指示点下标最大为 size-1；末尾吸附点必须收敛到最后一个点，
        // 否则 items[size] 越界导致滑到底时无高亮
        index = size >= INDICATOR_MAX ? INDICATOR_MAX - 1 : size - 1;
      } else if (size >= INDICATOR_MAX) {
        if (cardIndex < 5) {
          index = cardIndex;
        } else if (cardIndex >= maxScroll - 3) {
          index = 5 + (cardIndex - (maxScroll - 3));
        } else {
          index = 4;
        }
      } else {
        index = cardIndex;
      }

      cancelFlash();

      // prev 出死区进前段的第一步（activeIndex=4）：闪格 3 回 4，与死区中段反馈一致
      if (!instant && direction < 0 && cardIndex === 4 && size >= INDICATOR_MAX) {
        flashTo(3, 4);
        updateModes(4);
        return;
      }

      // 死区内步进：过冲动画（next 闪格 5 回 4，prev 闪格 3 回 4）
      // prev 往回时保持"后 5 大"，直到还剩 5 步（activeIndex=5）才切回"前 5 大"
      if (!instant && index === 4 && cardIndex > 4) {
        // prev 刚滑出末段的第一步（activeIndex = maxScroll-4）：激活格 4 但不播过冲动画
        if (direction < 0 && cardIndex === maxScroll - 4) {
          setActive(index);
          updateModes(5);
          return;
        }
        // prev 切换回"前 5 大"的那一步（activeIndex=5）：直接激活格 4，不播动画
        if (direction < 0 && cardIndex === 5) {
          setActive(index);
          updateModes(index);
          return;
        }
        flashTo(direction < 0 ? 3 : 5, index);
        updateModes(direction < 0 ? 5 : index);
        return;
      }

      setActive(index);
      updateModes(index);
    }

    items.forEach(function (el, index) {
      el.addEventListener('click', function () {
        var count = size;
        var isEven = count % 2 == 0;
        var middleIndex = isEven ? count / 2 - 1 : (count + 1) / 2;
        var target = index;

        if (index == 0) {
          target = 0;
        } else if (index < middleIndex) {
          target = index;
        } else if (index == count - 1) {
          target = maxScroll;
        } else if (maxScroll > size) {
          // 与 indicatorChange 的末段映射对齐：item i ↔ maxScroll - (size - 1 - i)，
          // 之前用 index + (maxScroll - size) 整体少 1 步，
          // 会导致点击倒数第二个点却点亮倒数第三个点
          target = maxScroll - (size - 1 - index);
        }

        swiper.slideTo(Math.min(target, maxScroll));
      });
    });

    if (swiper.__newsIndicatorChange) {
      swiper.off('slideChange', swiper.__newsIndicatorChange);
    }
    swiper.__newsIndicatorChange = function (sw) {
      var direction = sw.activeIndex >= sw.previousIndex ? 1 : -1;
      indicatorChange(sw.activeIndex, false, direction);

      // FED 埋点：活动卡片滑动切换
      if (window.FEDTrack) {
        window.FEDTrack.slide('fed_event_slide', {
          from_index: sw.previousIndex + 1,
          to_index: sw.activeIndex + 1,
        });
      }
    };
    swiper.on('slideChange', swiper.__newsIndicatorChange);

    if (swiper.__newsIndicatorBreakpoint) {
      swiper.off('breakpoint', swiper.__newsIndicatorBreakpoint);
    }
    swiper.__newsIndicatorBreakpoint = function () {
      initIndicator(swiper, container);
    };
    swiper.on('breakpoint', swiper.__newsIndicatorBreakpoint);

    // 初始化时不播放过冲动画
    indicatorChange(swiper.activeIndex, true);
  }

  function initAll() {
    document.querySelectorAll('[data-news-slide]').forEach(initNewsSlide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var container = document.querySelector('[data-news-slide="' + event.detail.sectionId + '"]');
    if (container) initNewsSlide(container);
  });
})();
